import { defineComponent } from 'vue';
import PluginItem from '@remote/components/PluginItem.vue';
import { IS_FIRST_SHOW_PLUGIN } from '@remote/constant';
export default defineComponent({
  components: {
    PluginItem
  },
  props: {
    plugin: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    const isFirst = localStorage.getItem(IS_FIRST_SHOW_PLUGIN);
    if (!isFirst) {
      this.isVisible = true;
    }
  },
  methods: {
    close() {
      localStorage.setItem(IS_FIRST_SHOW_PLUGIN, 'true');
      this.isVisible = false;
    }
  }
});